<ion-button size="small" fill="solid" expand="block" (click)="changeStatus($event)">
  {{ status }}<ion-icon slot="end" name="chevron-expand-outline"></ion-icon>
</ion-button>
